export const Roles = {
  ADMIN: "ADMIN",
  SUPER_ADMIN: "SUPER_ADMIN",
  VENDOR_ADMIN: "VENDOR_ADMIN",
  REPORTING_ADMIN: "REPORTING_ADMIN",
}